/* src/app/modules_v2/booking/locations/components/sections/location-service-section/location-service-delete-dialog.component.css */
/*# sourceMappingURL=location-service-delete-dialog.component.css.map */
